var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "mergeDialogClass",
      attrs: {
        visible: _vm.isShow,
        width: "600px",
        center: "",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
      },
      on: {
        close: _vm.closeDialog,
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c("div", { staticClass: "warnInfo" }, [
        false ? _c("i", { staticClass: "el-icon-warning" }) : _vm._e(),
        _c("div", { staticClass: "warnInfos" }, [
          _vm._v(
            " 所选订单含有预约发货订单，当前发货时间和消费者预约发货时间不符，请确认是否继续发货？ 订单编号：" +
              _vm._s(_vm.showopPickDateOrderList()) +
              " "
          ),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.closeDialog("close")
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.copyTextFn } },
            [_vm._v("复制预约发货订单号")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.ignoeOpPickDateOrderFn },
            },
            [_vm._v("全部发货")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.nolmalOpPickDateOrderFn },
            },
            [_vm._v("仅发货正常订单")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }